import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import '../../css/centeredContainer.css';
import '../../css/Home.css';

import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlayCircle, faFlask } from "@fortawesome/free-solid-svg-icons";


export default function Demo({ isNavOpen }) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const TEST_APP_URL = "https://yourschoolname.dnzify.com";

  // Normalize language (es-ES → es)
  const lang = i18n.language?.split('-')[0];

  // Pick video by language
  const demoVideoUrl =
    lang === 'es'
      ? `${process.env.PUBLIC_URL}/promoVideos/dnzify_spanish.mp4`
      : `${process.env.PUBLIC_URL}/promoVideos/dnzify_english.mp4`;


  const [showVideo, setShowVideo] = useState(false);

  return (
    <div className={isNavOpen ? 'body-squeezed' : 'body'}>
      <div className="plans-container" style={{ marginTop: '3rem' }}>
        {/* <h2 className="plans-title" style={{ marginBottom: '6rem' }}>
          {t('Demo.title', 'Explore DNZIFY')}
        </h2> */}

        <div className="plans-grid">

          {/* Watch demo video (temporary message) */}
          <div
            className="plan-card"
            style={{ cursor: 'pointer' }}
            onClick={() => navigate('/demo/video')}
          >
            <FontAwesomeIcon
              icon={faPlayCircle}
              size="3x"
              style={{ marginBottom: '1rem' }}
            />

            <h3>{t('Demo.watchTitle', 'Watch How It Works')}</h3>

            <p>
              {t(
                'Demo.watchDescription',
                'See how schools use DNZIFY to manage classes, levels, and students.'
              )}
            </p>



          </div>


          {/* Try test app */}
          <div
            className="plan-card"
            style={{ cursor: 'pointer' }}
            onClick={() => window.location.href = TEST_APP_URL}
          >
            <FontAwesomeIcon
              icon={faFlask}
              size="3x"
              style={{ marginBottom: '1rem' }}
            />

            <h3>{t('Demo.tryTitle', 'Try the Live Test App')}</h3>

            <p>
              {t(
                'Demo.tryDescription',
                'Explore the platform hands-on using our public demo school.'
              )}
            </p>
          </div>

        </div>
      </div>
    </div>
  );
}
